import { User } from "@/ts/common-types";
import { UserDataInitialValues } from "@/ts/constants";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const UserDataSlice = createSlice({
    name: "userData",
    initialState: {
        value: UserDataInitialValues
    },
    reducers: {
        updateUserData: (
            state,
            action: PayloadAction<User>
        ) => {
            state.value = action.payload;
        },
    },
});


export const { updateUserData } = UserDataSlice.actions;


export const userDataReducer = UserDataSlice.reducer;